import { useEffect, useRef, useState } from 'react';

const useInnerHeight = () => {
    const [innerHeight, setInnerHeight] = useState<number>(window.innerHeight);
    const animationFrameId = useRef<number>();

    useEffect(() => {
        const updateInnerHeight = () => {
            if (animationFrameId.current) {
                window.cancelAnimationFrame(animationFrameId.current);
            }
            animationFrameId.current = window.requestAnimationFrame(() => {
                setInnerHeight(window.innerHeight);
            });
        };
        window.addEventListener('resize', updateInnerHeight);

        return () => window.removeEventListener('resize', updateInnerHeight);
    }, []);

    return innerHeight;
};

export default useInnerHeight;
